/* CrochetSkein · ABD quantity lock — v13.1
   Digital PDF patterns: every cart line is kept at quantity 1.
   - Clamps quantities sent to /cart/add, /cart/change and /cart/update to 1.
   - After an add, any line that ended above 1 (same pattern added twice) is reset to 1
     and the drawer / cart sections returned to the theme are swapped for corrected ones.
   - On page load, any line above 1 (e.g. from a cart link) is reset and the cart UI refreshed.
   Removing items (quantity 0) is untouched. Bundle & Save already adds distinct items at 1. */
(function () {
  if (window.__abdQtyLock) return;
  window.__abdQtyLock = true;

  var nativeFetch = window.fetch.bind(window);
  var CART_RE = /\/cart\/(add|change|update)(\.js|\.json)?$/;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cartJsUrl = root + 'cart.js';
  var updateUrl = root + 'cart/update.js';

  function cartAction(input) {
    try {
      var url = typeof input === 'string' ? input : input instanceof URL ? input.href : null;
      if (!url) return null;
      var m = new URL(url, location.origin).pathname.match(CART_RE);
      return m ? m[1] : null;
    } catch (e) { return null; }
  }

  function clamp(q) {
    var n = parseInt(q, 10);
    return isNaN(n) ? q : Math.min(n, 1);
  }

  // Returns { body, sections, sectionsUrl } with quantities clamped to 1.
  function clampBody(action, body) {
    var out = { body: body, sections: null, sectionsUrl: null };
    if (!body) return out;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (body.has('quantity')) body.set('quantity', clamp(body.get('quantity')));
      var keys = [];
      body.forEach(function (v, k) { if (/^(items\[\d+\]\[quantity\]|updates\[.*\])$/.test(k)) keys.push(k); });
      keys.forEach(function (k) { body.set(k, clamp(body.get(k))); });
      out.sections = body.get('sections');
      out.sectionsUrl = body.get('sections_url');
      return out;
    }
    if (typeof body === 'string') {
      try {
        var j = JSON.parse(body);
        if (j && typeof j === 'object') {
          if ('quantity' in j) j.quantity = clamp(j.quantity);
          if (Array.isArray(j.items)) j.items.forEach(function (it) { if (it && 'quantity' in it) it.quantity = clamp(it.quantity); });
          if (Array.isArray(j.updates)) j.updates = j.updates.map(clamp);
          else if (j.updates && typeof j.updates === 'object') Object.keys(j.updates).forEach(function (k) { j.updates[k] = clamp(j.updates[k]); });
          out.sections = j.sections || null;
          out.sectionsUrl = j.sections_url || null;
          out.body = JSON.stringify(j);
        }
      } catch (e) { /* not JSON, leave unchanged */ }
    }
    return out;
  }

  function overOne(cart) {
    var updates = {}, found = false;
    (cart.items || []).forEach(function (it) { if (it.quantity > 1) { updates[it.key] = 1; found = true; } });
    return found ? updates : null;
  }

  // Resets any line above 1. Resolves to the /cart/update.js response (or null if nothing to fix).
  function normalizeCart(sections, sectionsUrl) {
    return nativeFetch(cartJsUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = overOne(cart);
        if (!updates) return null;
        var payload = { updates: updates };
        if (sections) payload.sections = Array.isArray(sections) ? sections.join(',') : sections;
        if (sectionsUrl) payload.sections_url = sectionsUrl;
        return nativeFetch(updateUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (r) { return r.json(); });
      });
  }

  window.fetch = function (input, init) {
    var action = cartAction(input);
    if (!action || !init || !init.body) return nativeFetch(input, init);

    var c = clampBody(action, init.body);
    var nextInit = Object.assign({}, init, { body: c.body });
    var request = nativeFetch(input, nextInit);
    if (action !== 'add') return request;

    return request.then(function (response) {
      if (!response.ok) return response;
      return response.clone().json().then(function (data) {
        if (data && data.status) return response; // Shopify error payload, let the theme show it
        return normalizeCart(c.sections, c.sectionsUrl).then(function (fixed) {
          if (!fixed) return response;
          if (fixed.sections) data.sections = fixed.sections;
          if (typeof data.quantity === 'number') data.quantity = 1;
          if (Array.isArray(data.items)) data.items.forEach(function (it) { it.quantity = 1; });
          return new Response(JSON.stringify(data), {
            status: response.status,
            statusText: response.statusText,
            headers: { 'Content-Type': 'application/json' }
          });
        });
      }).catch(function () { return response; });
    });
  };

  // Page-load safety net: covers cart links and any non-JS add to cart.
  function onLoad() {
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = document.querySelector('cart-items:not(cart-drawer-items)') !== null;
    var sections = drawer ? ['cart-drawer', 'cart-icon-bubble'] : ['cart-icon-bubble'];
    var guard = 'abd-qty-lock-reloaded';
    normalizeCart(sections, location.pathname).then(function (fixed) {
      if (!fixed) {
        try { sessionStorage.removeItem(guard); } catch (e) {}
        return;
      }
      if (onCartPage) {
        // Reload once so the cart page shows corrected totals; the guard prevents a reload loop.
        try { if (sessionStorage.getItem(guard)) return; sessionStorage.setItem(guard, '1'); } catch (e) { return; }
        location.reload();
        return;
      }
      var s = fixed.sections || {};
      var parse = function (html, sel) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector(sel);
        return el ? el.innerHTML : null;
      };
      if (drawer && s['cart-drawer']) {
        var inner = parse(s['cart-drawer'], '#CartDrawer');
        var target = document.getElementById('CartDrawer');
        if (inner !== null && target) target.innerHTML = inner;
      }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && s['cart-icon-bubble']) {
        var b = parse(s['cart-icon-bubble'], '.shopify-section');
        if (b !== null) bubble.innerHTML = b;
      }
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad);
  else onLoad();
})();
